
 
import React, { useState } from 'react';
import './TopTabsHeader.css';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';

function TnpTabsHeader(props) {
  const links = props?.moremenu;
  const [active, setActive] = useState(props.pageNo);
  const HandleClick = (index) => {
    setActive(index);
  }

  

  let dropdownCount = 0;
  for (const link of links) {
    if (link.dataType === 'dropdown') {
      dropdownCount++;
    }
  }


  return (
    <div className='tvg_topTabs_main'>
      <div className='contentWrap'>
        <div className='tvg_topTabs_row'>
          <ul className='tvg_topTabs_ul'>
            {links.map((link, index) => {
              return link.dataType === 'normal' ? <li id={link.id} key={link.id} className={`tvg_topTabs_li ${active === index ? 'active' : ''}`}  onClick={() =>  link?.hhandleClick? '' : HandleClick(index) }>
                <Link className='tvg_topTabs_box' onClick={link?.hhandleClick}
                  // to={`${link.path ?  '/'+link.path: null}`}
                  to={link.path ? '/'+link.path : ''}
                >
                  <div className='tvg_topTabs_icon' key={index} dangerouslySetInnerHTML={{ __html: link.icon }} ></div>
                  <p>{link.title}</p>
                  <div className='tvg_topTabs_price'>
                    <h3>{link.value}</h3>
                    <span>{link.valueType}</span>
                  </div>
                </Link>
              </li> : null;
            }
            )}

            {
              dropdownCount !== 0 ? <li className='tvg_topTabs_li'>
                <div className='tvg_toptab_more'>
                  <Dropdown>
                    <Dropdown.Toggle>
                      <div className='tvg_topTabs_box'>
                        <div className='tvg_topTabs_icon'>
                          <svg width="22" height="8" viewBox="0 0 22 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0614 6.68268C19.543 6.68268 20.7441 5.48162 20.7441 4.00003C20.7441 2.51845 19.543 1.31738 18.0614 1.31738C16.5798 1.31738 15.3788 2.51845 15.3788 4.00003C15.3788 5.48162 16.5798 6.68268 18.0614 6.68268Z" fill="#ED664C" /><path d="M10.6171 6.68268C12.0987 6.68268 13.2997 5.48162 13.2997 4.00003C13.2997 2.51845 12.0987 1.31738 10.6171 1.31738C9.13548 1.31738 7.93442 2.51845 7.93442 4.00003C7.93442 5.48162 9.13548 6.68268 10.6171 6.68268Z" fill="#F5C24C" /><path d="M3.17274 6.68268C4.65433 6.68268 5.8554 5.48162 5.8554 4.00003C5.8554 2.51845 4.65433 1.31738 3.17274 1.31738C1.69115 1.31738 0.490082 2.51845 0.490082 4.00003C0.490082 5.48162 1.69115 6.68268 3.17274 6.68268Z" fill="#44C4A1" /><path d="M10.617 0.848633C9.99367 0.848633 9.38438 1.03346 8.86613 1.37974C8.34788 1.72602 7.94396 2.21821 7.70544 2.79405C7.46691 3.3699 7.40451 4.00354 7.5261 4.61486C7.6477 5.22617 7.94784 5.7877 8.38858 6.22843C8.82931 6.66917 9.39083 6.96931 10.0021 7.09091C10.6135 7.2125 11.2471 7.1501 11.8229 6.91157C12.3988 6.67305 12.891 6.26912 13.2373 5.75088C13.5835 5.23263 13.7684 4.62334 13.7684 4.00005C13.7674 3.16453 13.4351 2.3635 12.8443 1.7727C12.2535 1.1819 11.4525 0.849576 10.617 0.848633V0.848633ZM10.617 6.21396C10.1791 6.21396 9.75105 6.08411 9.38698 5.84085C9.0229 5.59758 8.73914 5.25181 8.57157 4.84727C8.40401 4.44273 8.36016 3.99759 8.44559 3.56813C8.53101 3.13868 8.74187 2.7442 9.05149 2.43457C9.36111 2.12495 9.75559 1.9141 10.185 1.82867C10.6145 1.74325 11.0596 1.78709 11.4642 1.95466C11.8687 2.12222 12.2145 2.40599 12.4578 2.77006C12.701 3.13414 12.8309 3.56218 12.8309 4.00005C12.8302 4.58701 12.5967 5.14975 12.1817 5.56479C11.7667 5.97984 11.2039 6.2133 10.617 6.21396V6.21396ZM18.0612 0.848633C17.4379 0.848633 16.8286 1.03346 16.3103 1.37974C15.7921 1.72602 15.3882 2.21821 15.1497 2.79405C14.9111 3.3699 14.8487 4.00354 14.9703 4.61486C15.0919 5.22617 15.3921 5.7877 15.8328 6.22843C16.2735 6.66917 16.8351 6.96931 17.4464 7.09091C18.0577 7.2125 18.6913 7.1501 19.2672 6.91157C19.843 6.67305 20.3352 6.26912 20.6815 5.75088C21.0278 5.23263 21.2126 4.62334 21.2126 4.00005C21.2116 3.16453 20.8793 2.3635 20.2885 1.7727C19.6977 1.1819 18.8967 0.849576 18.0612 0.848633V0.848633ZM18.0612 6.21396C17.6233 6.21396 17.1953 6.08411 16.8312 5.84085C16.4671 5.59758 16.1834 5.25181 16.0158 4.84727C15.8482 4.44273 15.8044 3.99759 15.8898 3.56813C15.9752 3.13868 16.1861 2.7442 16.4957 2.43457C16.8053 2.12495 17.1998 1.9141 17.6293 1.82867C18.0587 1.74325 18.5039 1.78709 18.9084 1.95466C19.3129 2.12222 19.6587 2.40599 19.902 2.77006C20.1452 3.13414 20.2751 3.56218 20.2751 4.00005C20.2744 4.58701 20.0409 5.14973 19.6259 5.56478C19.2109 5.97982 18.6481 6.21329 18.0612 6.21396V6.21396ZM0.0213318 4.00005C0.0213318 4.62334 0.206159 5.23263 0.55244 5.75088C0.89872 6.26912 1.3909 6.67305 1.96675 6.91157C2.54259 7.1501 3.17623 7.2125 3.78755 7.09091C4.39886 6.96931 4.96039 6.66917 5.40112 6.22843C5.84185 5.7877 6.14199 5.22617 6.26359 4.61486C6.38519 4.00354 6.32278 3.3699 6.08426 2.79405C5.84573 2.21821 5.44181 1.72602 4.92357 1.37974C4.40532 1.03346 3.79603 0.848633 3.17274 0.848633C2.33722 0.849576 1.5362 1.1819 0.945399 1.7727C0.3546 2.3635 0.0222747 3.16453 0.0213318 4.00005V4.00005ZM5.38664 4.00005C5.38664 4.43792 5.2568 4.86595 5.01353 5.23003C4.77027 5.59411 4.4245 5.87787 4.01996 6.04543C3.61542 6.213 3.17028 6.25684 2.74083 6.17142C2.31137 6.08599 1.91689 5.87514 1.60727 5.56552C1.29765 5.2559 1.0868 4.86142 1.00137 4.43196C0.915947 4.0025 0.95979 3.55736 1.12736 3.15282C1.29492 2.74828 1.57868 2.40251 1.94276 2.15925C2.30683 1.91598 2.73487 1.78613 3.17274 1.78613C3.7597 1.7868 4.32242 2.02027 4.73747 2.43531C5.15251 2.85036 5.38597 3.41309 5.38664 4.00005V4.00005Z" fill="black" /></svg>
                        </div>
                        <p>Show More</p>
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {links.map((link, index) => {
                        return link.dataType === 'dropdown' ? <Link to={`/${link.path}`} id={link.id} key={link.id} className={`tvg_topTabs_li ${active === index ? 'active' : ''}`} onClick={() => HandleClick(index)}>
                          <div className='tvg_topTabs_box'>
                            <div className='tvg_topTabs_icon' key={index} dangerouslySetInnerHTML={{ __html: link.icon }} ></div>
                            <p>{link.title}</p>
                            {link.gridValue !== undefined ? <div className='tvg_topTabs_price tvg_price_border'>
                              <h3>{link.gridValue}</h3>
                              <span>{link.gridValueType}</span>
                            </div> : null}
                            <div className='tvg_topTabs_price'>
                              <h3>{link.value}</h3>
                              <span>{link.valueType}</span>
                            </div>
                          </div>
                        </Link> : null;
                      }
                      )}

                    </Dropdown.Menu>
                  </Dropdown>
                </div>

              </li>
                :
                ''
            }

          </ul>
        </div>
      </div>
    </div>
  )

}



export default TnpTabsHeader;
